import { RestoreableModel, ResourceFactory } from '../services/';

class Campaign extends RestoreableModel {
  public name:                 string = '';
  public date:                 string = null;
  public description:          string = null;
  public freshwater_discharge: number;
  public tidal_amplitude:      number;
  public tidal_situation:      string;
  public high_time:            string;
  public low_time:             string;
  public radiation:            number;
  public rainfall:             number;
  public high_temperature:     number;
  public low_temperature:      number;
  public wind_direction:       number;
  public wind_speed:           number;
  public weather:              string;

  public samples_count: number;

  public project: { 
    id: number;
    name: string;
  } = null;  
}

const CampaignFactory = ResourceFactory.create<Campaign>(Campaign, 'campaign');

export { Campaign, CampaignFactory };
